import * as Sentry from '@sentry/react';

import { isProductionApp } from '@/core/helpers/isProductionApp';

export function initSentry(
  dsn: string = 'https://5b0bc1c65eb281d9371aa7cdfe520b96@o4508737229553664.ingest.de.sentry.io/4508755473072208',
) {
  Sentry.init({
    dsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    enabled: isProductionApp(),
  });
}
